import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import Dialog from '@/components/Dialog';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import type { Course, LearnPage } from '@edwin-group/cj-graphql/generated/graphql';
import Button from '@/components/Button';
import { PendingLesson } from '../../pages/learn/course-lesson';

function DialogConfirmMarkCourseAsCompleted({
  open,
  setOpen,
  lessons,
  course,
  learnPage,
}: {
  open?: boolean;
  setOpen: React.Dispatch<boolean>;
  lessons: PendingLesson[];
  course: Course;
  learnPage?: LearnPage | null;
}) {
  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={learnPage?.modalMarkCourseAsCompleted?.title || 'Are you sure you want to mark this course as complete?'}
      body={
        <>
          <p className="text-justify text-sh-sm">
            {learnPage?.modalMarkCourseAsCompleted?.description ||
              "It looks like you haven't completed all the lessons yet. Here’s a list of the lessons you still need to finish. Are you sure you want to mark the course as complete?"}
          </p>
          <div>
            <ul className="!pl-0 font-cadiz text-sh-xxs">
              {lessons &&
                lessons?.map((lesson) => {
                  return (
                    <ol className={classNames('!pl-0')} key={lesson?.id}>
                      <AnimatedFadeInComponent>
                        <Link
                          onClick={() => {
                            setOpen(false);
                          }}
                          to={`/learn/course/${course?.slug}/module/${lesson?.idModule}/lesson/${lesson?.id}`}
                          className="mb-sh-15 flex items-center">
                          {lesson?.title}
                        </Link>
                      </AnimatedFadeInComponent>
                    </ol>
                  );
                })}
            </ul>
          </div>
          <div className="flex items-start justify-start gap-4">
            <Button
              theme="outline"
              onClick={() => {
                setOpen(false);
              }}>
              {learnPage?.modalMarkCourseAsCompleted?.cancelButton || 'Go Back'}
            </Button>
          </div>
        </>
      }
    />
  );
}

export default DialogConfirmMarkCourseAsCompleted;
